import { isWithinInterval, UTCDate } from '@/utils/dates';
import { TransactionView } from '../../../types/entity-types';

type GetTransactionsInTimeframeArgs = {
  transactions: TransactionView[];
  startDate: Date;
  endDate: Date;
};

export const getTransactionsInTimeframe = ({ transactions, startDate, endDate }: GetTransactionsInTimeframeArgs) => {
  return transactions.filter((t) => isWithinInterval(new UTCDate(t.fspDate), { start: startDate, end: endDate }));
};
